import { Clear, LocalPrintshopOutlined, Search } from "@mui/icons-material";
import {
  Alert,
  Autocomplete,
  Box,
  Chip,
  createFilterOptions,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Snackbar,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";

import useStyles from "./styles";
import dayjs from "dayjs";
import { useOutletContext } from "react-router-dom";
import { useEffect, useState } from "react";
import customParseFormat from "dayjs/plugin/customParseFormat";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import DatagridComponent from "../../../../components/datagridComponent";
import FilterBar from "../../../../components/topBarFilter";
import GrupoChip from "../../../../components/grupoEconomico/GrupoChip";
dayjs.extend(customParseFormat);

function erpConfig(erp) {
  let erpObj = { columnsErpType: "", labelErp: "" };

  switch (erp) {
    case "HUBSOFT":
      erpObj = {
        columnsErpType: erp.toLowerCase(),
        labelErp: "Serviço",
        labelRef: "Referência",
      };
      break;

    case "VOALLE":
      erpObj = {
        columnsErpType: erp.toLowerCase(),
        labelErp: "Contrato",
        labelRef: "",
      };
      break;
    case "IXC":
      erpObj = {
        columnsErpType: erp.toLowerCase(),
        labelErp: "Contrato",
        labelRef: "Descrição auxiliar",
      };
      break;
    case "VERO":
      erpObj = {
        columnsErpType: erp.toLowerCase(),
        labelErp: "Contrato",
        labelRef: "",
      };
      break;
  }
  return erpObj;
}

export default function Faturas() {
  const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP || "";
  const { apiCliente, controllerDashboard, setControllerDashboard } =
    useOutletContext();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [clienteInfo, setClienteInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const [allServices, setAllService] = useState([]);
  const [rows, setRows] = useState([]);
  const [buscarFatura, setBuscarFatura] = useState("");
  const [selectService, setSelectService] = useState({});
  const [openFilter, setOpenFilter] = useState(false);
  const filter = createFilterOptions();
  const [snackbar, setSnackbar] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const { columnsErpType, labelErp } = erpConfig(erp);
  const configErpRef = (invertInfo) => {
    switch (erp) {
      case "HUBSOFT":
        return {
          labelRef: invertInfo ? "Serviço" : "Referência",
        };
        break;
      case "IXC":
        return {
          labelRef: invertInfo ? "Contrato" : "Descrição auxiliar",
        };
        break;
      default:
        return {
          labelRef: "",
        };
        break;
    }
  };

  // Usuário de grupo econômico: as faturas consolidadas chegam com o membro
  // dono (ownerNome) — exibe a coluna "Empresa" somente nesse caso
  const temEmpresaGrupo = rows?.some((row) => !!row?.ownerNome);

  const filteredRows = rows?.filter((row) => {
    const valorFatura = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(Number(row?.valor || 0));

    const valorPago = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(Number(row?.valor_pago || 0));

    const servico =
      erp !== "VERO"
        ? `${row?.cliente?.servico?.id_cliente_servico} - ${row?.cliente?.servico?.nome}`
        : `${row?.id_cliente_servico} - ${row?.nome}`;

    const matchesText =
      row.data_vencimento
        ?.toLowerCase()
        ?.includes(buscarFatura?.toLowerCase()) ||
      row.data_cadastro?.toLowerCase()?.includes(buscarFatura?.toLowerCase()) ||
      row.data_pagamento
        ?.toLowerCase()
        ?.includes(buscarFatura?.toLowerCase()) ||
      row.status?.toLowerCase()?.includes(buscarFatura?.toLowerCase()) ||
      valorFatura?.toLowerCase()?.includes(buscarFatura?.toLowerCase()) ||
      valorPago?.toLowerCase()?.includes(buscarFatura?.toLowerCase()) ||
      row.ownerNome?.toLowerCase()?.includes(buscarFatura?.toLowerCase()) ||
      servico?.toLowerCase()?.includes(buscarFatura?.toLowerCase());

    const idServicoDaLinha =
      erp !== "VERO"
        ? row?.cliente?.servico?.id_cliente_servico
        : row?.id_cliente_servico;

    const matchesService =
      !selectService || idServicoDaLinha === selectService?.id_cliente_servico;

    return matchesText && matchesService;
  });

  const statusPagamento = {
    pago: <Chip sx={styles.chipPago} label={"Pago"} />,
    aguardando: <Chip sx={styles.chipAguardando} label={"Aguardando"} />,
    vencido: <Chip sx={styles.chipVencido} label={"Vencido"} />,
    "a receber": <Chip sx={styles.chipAguardando} label={"A receber"} />,
    "em atraso": <Chip sx={styles.chipVencido} label={"Em atraso"} />,
    cancelado: <Chip sx={styles.chipCancelado} label={"Cancelado"} />,
    recebido: <Chip sx={styles.chipPago} label={"Recebido"} />,
    renegociado: <Chip sx={styles.chipRenegociado} label={"Renegociado"} />,
  };

  const fetchAllData = async () => {
    try {
      switch (erp) {
        case "HUBSOFT":
          await getFaturas();
          break;

        case "VOALLE":
          await getFaturas();
          break;

        case "IXC":
          await getFaturas();
          break;
        case "VERO":
          await getFaturas(clienteInfo?.usuarioCliente?.cliente?.clienteErpId);
          break;
        default:
          setSnackbar({
            children: "Erro: ERP não foi configurado",
            severity: "error",
          });
          break;
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (clienteInfo?.usuarioCliente?.clienteId) {
      fetchAllData();
    }
  }, [clienteInfo]);
  useEffect(() => {
    setClienteInfo(JSON.parse(localStorage.getItem("userCliente")));

    return () => {
      if (controllerDashboard) {
        controllerDashboard.abort();
      }
    };
  }, []);

  //Função para uso exclusivo do voalle
  async function downloadFatura(faturaId) {
    try {
      window.open(
        (window?.config?.REACT_APP_BASE_URL || process.env.REACT_APP_BASE_URL) +
          `/download/voalle/fatura?faturaId=${faturaId}`,
        "_blank",
      );
    } catch {
    } finally {
    }
  }

  const getFaturas = async (clienteErpId) => {
    if (controllerDashboard) {
      controllerDashboard.abort();
    }
    const newController = new AbortController();
    const signal = newController.signal;

    setControllerDashboard(newController);
    try {
      setAllService([]);
      setSelectService(null);
      setBuscarFatura("");
      setLoading(true);

      const response = await apiCliente.post(
        "/cliente/find/faturas",
        {
          clienteId: clienteInfo?.usuarioCliente?.clienteId,
          clienteErpId: clienteErpId,
        },
        {
          signal,
        },
      );

      setRows(
        response?.data?.faturas?.map((fatura) => ({
          id: fatura?.id_fatura,
          ...fatura,
        })),
      );

      setAllService(response?.data?.servicos || []);
    } catch (error) {
      console.error("Error fetching faturaws:", error);
    } finally {
      setLoading(false);
    }
  };
  const columnsHubsoft = [
    {
      field: "servico",
      headerName: "Serviço",
      flex: 1.5,
      valueGetter: (params, row) =>
        `${row?.servico?.id_cliente_servico} - ${row?.servico?.nome}`,

      renderCell: (params) => {
        const servico = params.row.cliente?.servico;
        if (!servico) return "";
        return `${servico.id_cliente_servico} - ${servico.nome}`;
      },
    },
    // Coluna exibida apenas para usuários de grupo econômico
    ...(temEmpresaGrupo
      ? [
          {
            field: "ownerNome",
            headerName: "Empresa",
            flex: 1.2,
            renderCell: (params) =>
              params?.row?.ownerNome ? (
                <GrupoChip variant="owner" label={params?.row?.ownerNome} />
              ) : (
                ""
              ),
          },
        ]
      : []),
    {
      field: "valor",
      headerName: "Valor da fatura",
      flex: 1,
      renderCell: (params) =>
        new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(Number(params?.value || 0)),
    },
    {
      field: "data_vencimento",
      headerName: "Data Vencimento",
      flex: 1,
      valueGetter: (params) => dayjs(params, "DD/MM/YYYY", true).toDate(),
      renderCell: (params) => dayjs(params.value).format("DD/MM/YYYY"),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => statusPagamento[params?.value],
    },
    {
      field: "data_cadastro",
      headerName: "Data de cadastro",
      flex: 1,
      valueGetter: (params) => dayjs(params, "DD/MM/YYYY", true).toDate(),
      renderCell: (params) => dayjs(params.value).format("DD/MM/YYYY"),
    },
    {
      field: "valor_pago",
      headerName: "Valor Pago",
      flex: 1,
      renderCell: (params) =>
        params?.value
          ? new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(Number(params?.value || 0))
          : "",
    },
    {
      field: "data_pagamento",
      headerName: "Data de pagamento",
      flex: 1,
      valueGetter: (params) =>
        params ? dayjs(params, "DD/MM/YYYY", true)?.toDate() : "",
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("DD/MM/YYYY") : "",
    },

    {
      field: " ",
      headerName: " ",
      maxWidth: 16,
      sortable: false,

      renderCell: (params) => (
        <IconButton
          onClick={() =>
            window.open(params.row.link, "_blank", "noopener,noreferrer")
          }
          size="small"
        >
          <LocalPrintshopOutlined fontSize="small" />
        </IconButton>
      ),
    },
  ];
  const columnsVoalle = [
    {
      field: "servico",
      headerName: "Serviço",
      flex: 1.5,
      valueGetter: (params, row) =>
        `${row?.servico?.id_cliente_servico} - ${row?.servico?.nome}`,

      renderCell: (params) => {
        const servico = params.row.cliente?.servico;
        if (!servico) return "";
        return `${servico?.id_cliente_servico || ""} - ${servico?.nome || ""}`;
      },
    },
    // Coluna exibida apenas para usuários de grupo econômico
    ...(temEmpresaGrupo
      ? [
          {
            field: "ownerNome",
            headerName: "Empresa",
            flex: 1.2,
            renderCell: (params) =>
              params?.row?.ownerNome ? (
                <GrupoChip variant="owner" label={params?.row?.ownerNome} />
              ) : (
                ""
              ),
          },
        ]
      : []),
    {
      field: "valor",
      headerName: "Valor da fatura",
      flex: 1,
      renderCell: (params) =>
        new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(Number(params?.value || 0)),
    },
    {
      field: "data_vencimento",
      headerName: "Data Vencimento",
      flex: 1,
      valueGetter: (params) => dayjs(params, "DD/MM/YYYY", true).toDate(),
      renderCell: (params) => dayjs(params.value).format("DD/MM/YYYY"),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => statusPagamento[params?.value],
    },
    {
      field: "valor_pago",
      headerName: "Valor pago",
      flex: 1,
      renderCell: (params) =>
        params?.value &&
        new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(Number(params?.value || 0)),
    },
    {
      field: "data_pagamento",
      headerName: "Data pagamento",
      flex: 1,
      valueGetter: (params) =>
        params && dayjs(params, "DD/MM/YYYY", true).toDate(),
      renderCell: (params) =>
        params.value && dayjs(params.value).format("DD/MM/YYYY"),
    },
    {
      field: "data_cadastro",
      headerName: "Data de cadastro",
      flex: 1,
      valueGetter: (params) => dayjs(params, "DD/MM/YYYY", true).toDate(),
      renderCell: (params) => dayjs(params.value).format("DD/MM/YYYY"),
    },

    {
      field: " ",
      headerName: " ",
      maxWidth: 16,
      sortable: false,

      renderCell: (params) => (
        <IconButton
          onClick={() => downloadFatura(params.row.id_fatura)}
          size="small"
        >
          <LocalPrintshopOutlined fontSize="small" />
        </IconButton>
      ),
    },
  ];
  const columnsIxc = [
    {
      field: "servico",
      headerName: "Serviço",
      flex: 1.5,
      valueGetter: (params, row) => `${row?.id_cliente_servico} - ${row?.nome}`,

      renderCell: (params) => {
        if (!params?.row?.id_cliente_servico && !params?.row?.nome) return "";
        return `${params?.row?.id_cliente_servico} - ${params?.row?.nome}`;
      },
    },
    // Coluna exibida apenas para usuários de grupo econômico (IXC)
    ...(temEmpresaGrupo
      ? [
          {
            field: "ownerNome",
            headerName: "Empresa",
            flex: 1.2,
            renderCell: (params) =>
              params?.row?.ownerNome ? (
                <GrupoChip variant="owner" label={params?.row?.ownerNome} />
              ) : (
                ""
              ),
          },
        ]
      : []),
    {
      field: "valor",
      headerName: "Valor da fatura",
      flex: 1,
      renderCell: (params) =>
        new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(Number(params?.value || 0)),
    },
    {
      field: "num_cobranca",
      headerName: "Nº de cobrança",
      flex: 1,
    },
    {
      field: "data_vencimento",
      headerName: "Data Vencimento",
      flex: 1,

      renderCell: (params) => {
        return dayjs(params.value).format("DD/MM/YYYY");
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => statusPagamento[params?.value],
    },
    {
      field: "data_cadastro",
      headerName: "Data de cadastro",
      flex: 1,

      renderCell: (params) => dayjs(params.value).format("DD/MM/YYYY"),
    },
    {
      field: "valor_pago",
      headerName: "Valor Pago",
      flex: 1,
      renderCell: (params) =>
        params?.value
          ? new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(Number(params?.value || 0))
          : "",
    },
    {
      field: "data_pagamento",
      headerName: "Data de pagamento",
      flex: 1,

      renderCell: (params) =>
        params.value ? dayjs(params.value).format("DD/MM/YYYY") : "",
    },

    {
      field: " ",
      headerName: " ",
      maxWidth: 16,
      sortable: false,
      renderCell: (params) => {
        const isValidUrl = (urlString) => {
          if (!urlString) return false;

          try {
            const url = new URL(urlString);

            return url.protocol === "http:" || url.protocol === "https:";
          } catch (error) {
            return false;
          }
        };
        const isLinkValid = isValidUrl(params?.row?.link);

        return (
          <IconButton
            disabled={!isLinkValid}
            onClick={() => {
              if (isLinkValid) {
                window.open(params.row.link, "_blank", "noopener,noreferrer");
              }
            }}
            size="small"
            title={
              !isLinkValid
                ? "Link de impressão indisponível"
                : "Imprimir fatura"
            }
          >
            <LocalPrintshopOutlined fontSize="small" />
          </IconButton>
        );
      },
    },
  ];

  const columnsVero = [
    {
      field: "servico",
      headerName: "Contrato",
      flex: 1.5,
      valueGetter: (params, row) =>
        `${row?.id_cliente_servico || ""} - ${row?.nome || ""}`,
      renderCell: (params) => {
        if (!params?.row?.id_cliente_servico && !params?.row?.nome) return "";
        return `${params?.row?.id_cliente_servico} - ${params?.row?.nome}`;
      },
    },
    // Coluna exibida apenas para usuários de grupo econômico
    ...(temEmpresaGrupo
      ? [
          {
            field: "ownerNome",
            headerName: "Empresa",
            flex: 1.2,
            renderCell: (params) =>
              params?.row?.ownerNome ? (
                <GrupoChip variant="owner" label={params?.row?.ownerNome} />
              ) : (
                ""
              ),
          },
        ]
      : []),
    {
      field: "valor",
      headerName: "Valor da fatura",
      flex: 1,
      renderCell: (params) =>
        new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(Number(params?.value || 0)),
    },
    {
      field: "data_vencimento",
      headerName: "Data Vencimento",
      flex: 1,

      valueGetter: (params) => (params ? dayjs(params).toDate() : null),
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("DD/MM/YYYY") : "",
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,

      renderCell: (params) =>
        statusPagamento[params?.value?.toLowerCase()] || (
          <Chip label={params?.value} />
        ),
    },
    {
      field: "data_cadastro",
      headerName: "Data de Emissão",
      flex: 1,
      valueGetter: (params) => (params ? dayjs(params).toDate() : null),
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("DD/MM/YYYY") : "",
    },
    {
      field: "valor_pago",
      headerName: "Valor Pago",
      flex: 1,
      renderCell: (params) =>
        params?.value
          ? new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(Number(params?.value || 0))
          : "",
    },
    {
      field: "data_pagamento",
      headerName: "Data de pagamento",
      flex: 1,
      valueGetter: (params) => (params ? dayjs(params).toDate() : null),
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("DD/MM/YYYY") : "",
    },
    {
      field: " ",
      headerName: " ",
      maxWidth: 16,
      sortable: false,
      renderCell: (params) => {
        // Verifica se veio um link externo ou se veio o ID do documento da Vero
        const hasLink = !!params?.row?.link;
        const hasDoc = !!params?.row?.cod_arq_doc;

        return (
          <IconButton
            disabled={!hasLink && !hasDoc}
            onClick={() => {
              if (hasLink) {
                window.open(params.row.link, "_blank", "noopener,noreferrer");
              } else if (hasDoc) {
                const baseUrl =
                  window?.config?.REACT_APP_BASE_URL ||
                  process.env.REACT_APP_BASE_URL ||
                  "";

                window.open(
                  `${baseUrl}/download/vero/fatura?faturaId=${params.row.id_fatura}&docId=${params.row.cod_arq_doc}`,
                  "_blank",
                );
              }
            }}
            size="small"
          >
            <LocalPrintshopOutlined fontSize="small" />
          </IconButton>
        );
      },
    },
  ];
  const columnsErp = {
    hubsoft: columnsHubsoft,
    voalle: columnsVoalle,
    ixc: columnsIxc,
    vero: columnsVero,
  };

  const actions = [
    {
      icon: <FilterAltOutlinedIcon />,
      name: "Filtro",
      onClick: () => setOpenFilter(true),
    },
  ];

  return (
    <>
      <FilterBar
        selectorComponentLeft={
          <Box sx={styles.containerActions}>
            <TextField
              label="Buscar fatura"
              variant="outlined"
              autoComplete="off"
              sx={{
                width: "100%",
                maxWidth: 500,
              }}
              placeholder={`${labelErp}, vencimento, etc...`}
              value={buscarFatura}
              size="small"
              onChange={(event) => {
                setBuscarFatura(event?.target?.value?.trimStart());
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
                endAdornment: buscarFatura ? (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setBuscarFatura("")} edge="end">
                      <Clear size={"small"} />
                    </IconButton>
                  </InputAdornment>
                ) : null,
              }}
            />
            <Autocomplete
              id="free-solo-demo"
              value={selectService}
              disabled={loading}
              size="small"
              sx={{
                width: "100%",
                maxWidth: 500,
              }}
              options={allServices || []}
              getOptionLabel={(option) => {
                if (option?.id_cliente_servico && option?.nome) {
                  return `${option.id_cliente_servico} - ${option.nome}`;
                }
                return "";
              }}
              onChange={(event, newValue) => {
                setSelectService(newValue);
              }}
              renderInput={(params) => (
                <TextField {...params} label={labelErp} />
              )}
              renderOption={(props, option) => {
                const { key, ...optionProps } = props;

                // Se não houver referência, renderiza o formato simples (padrão)
                if (!option.referencia) {
                  return (
                    <li key={key} {...optionProps}>
                      {`${option.id_cliente_servico} - ${option.nome}`}
                    </li>
                  );
                }

                // Se houver referência, renderiza o formato personalizado
                return (
                  <li key={key} {...optionProps}>
                    <Box sx={styles.boxLine}>
                      <span style={{ fontWeight: "bold" }}>
                        {`${option.id_cliente_servico} - ${option.nome}`}
                      </span>
                      {option.referencia?.trim() && (
                        <>
                          <Divider sx={{ margin: "2px 0" }} />
                          <span style={{ fontSize: "0.85rem", opacity: 0.9 }}>
                            <span style={{ fontWeight: "bold" }}>
                              {configErpRef(option?.invertInfo).labelRef}:
                            </span>{" "}
                            {option.referencia}
                          </span>
                        </>
                      )}
                    </Box>
                  </li>
                );
              }}
              filterOptions={(options, params) => {
                const filtered = filter(options, params);

                // Se a pesquisa normal não encontrar nada, ou se você quiser forçar a busca em outros campos:
                return options.filter(
                  (option) =>
                    option.nome
                      ?.toLowerCase()
                      .includes(params.inputValue.toLowerCase()) ||
                    option.id_cliente_servico
                      ?.toString()
                      .includes(params.inputValue) ||
                    option.referencia
                      ?.toLowerCase()
                      .includes(params.inputValue.toLowerCase()),
                );
              }}
            />
          </Box>
        }
        selectorComponentRight={<Box sx={{ width: "1px" }} />}
        setOpenFilter={setOpenFilter}
        openFilter={openFilter}
        actions={actions}
      />
      <Paper
        sx={styles.containerPaper}
        elevation={theme.palette.mode === "dark" ? 0 : 3}
      >
        <Typography variant="mySubtitle">Faturas</Typography>

        <Box sx={{ height: "500px" }}>
          <DatagridComponent
            loading={loading}
            rows={filteredRows}
            columns={columnsErpType ? columnsErp[columnsErpType] : []}
          />
        </Box>
      </Paper>
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </>
  );
}
